
import EnvironmentModel from "./environment.model"

let env: EnvironmentModel = {
    env: "dev",
    serverUrl: "http://localhost:8888/defender/back/apis",
};

const getEnv = (urlAtual: string) => {
    if ((urlAtual).indexOf('a7apps') >= 0) { // hml
        env = {
            env: "hml",
            serverUrl: "https://defender.a7apps.com/back/apis",
        };
    } else if ((urlAtual).indexOf('prod') >= 0) { // prod
        env = {
            env: "prd",
            serverUrl: "https://touchpoint-backend.elo.com.br",
        };
    } else if ((urlAtual).indexOf('localhost') >= 0) { // local
        env = {
            env: "local",
            serverUrl: "http://localhost:8888/defender/back/apis",
        };
    }
    
    return env;
}

export const environment: EnvironmentModel = getEnv(window.location.host);
